import { Column } from "@repo/components/src/shared/dataGrid/types";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { formatSeparators } from "@repo/components/src/utils/numbers";
import { ListCampaignsWithReportQuery } from "@repo/graphql/documents/campaign/query.generated";
import dayjs from "dayjs";
import { Link } from "expo-router";
import type { ReactNode } from "react";
import CampaignTitleCell from "./campaignTitleCell";

export type FinishedCampaignEdge =
  ListCampaignsWithReportQuery["campaign"]["list"]["edges"][number];
type CampaignEdge = FinishedCampaignEdge;

const formatDate = (value: string | null | undefined) => {
  if (!value) return "—";
  const d = dayjs(value);
  return d.isValid() ? d.format("D MMM YYYY") : "—";
};

export const finishedCampaignColumns = ({
  brandId,
  renderAction,
}: {
  brandId: string;
  /** Overrides the trailing action cell — defaults to the "Ver campaña"
   * link the campaigns screen uses. */
  renderAction?: (edge: CampaignEdge) => ReactNode;
}): Column<CampaignEdge>[] => [
  {
    id: "campaign",
    header: "Campaña",
    sortable: false,
    render: ({ node }) => (
      <CampaignTitleCell campaign={node} brandId={brandId} />
    ),
  },
  {
    id: "created",
    header: "Creada",
    width: 140,
    sortable: false,
    getValue: ({ node }) => formatDate(node.createdAt),
  },
  {
    id: "closed",
    header: "Cerrada",
    width: 140,
    sortable: false,
    getValue: ({ node }) => formatDate(node.finishedAt),
  },
  {
    id: "createdBy",
    header: "Creada por",
    width: 180,
    sortable: false,
    getValue: ({ node }) => node.createdBy?.fullName ?? "—",
  },
  {
    id: "creators",
    header: "Creadores",
    width: 120,
    sortable: false,
    getValue: ({ node }) => formatSeparators(node.creatorsWithWorkOrders),
  },
  {
    id: "content",
    header: "Contenidos",
    width: 120,
    sortable: false,
    getValue: ({ node }) => formatSeparators(node.approvedContentCount),
  },
  {
    id: "action",
    header: "",
    width: 160,
    sortable: false,
    render: (edge) =>
      renderAction ? (
        renderAction(edge)
      ) : (
        <Link
          href={{
            pathname:
              "/app/(brands)/[brandId]/(main)/campaign/[campaignId]" as const,
            params: { brandId, campaignId: edge.node.id },
          }}
          asChild
        >
          <Button action="brand" variant="outline" size="xs" rounded="lg">
            <ButtonText>Ver campaña</ButtonText>
          </Button>
        </Link>
      ),
  },
];
